const queryString = {
  parse: function (url = location.search) {
    let query;

    query = {};
    url = url.split('?')[1];

    if (url) {
      url = url.split('&');

      url.map(function (item) {
        item = item.split('=');

        query[item[0]] = decodeURIComponent(item[1]);
      });
    }

    return query;
  },

  build: function (queryObject) {
    let query, key;

    query = [];

    for (key in queryObject) {
      query.push(key + '=' + encodeURIComponent(queryObject[key]));
    }

    return query.join('&');
  },

  get(key, search = location.search) {
    let val = ''

    if (key) {
      let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
      let r = search.substr(1).match(reg)
      if (r && r.length > 0) {
        val = decodeURIComponent(r[2])
      }
    }

    return val
  }
};

export default queryString;



// WEBPACK FOOTER //
// ./src/utils/query-string.js